import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Person } from "@mui/icons-material";
import { Button } from "@mui/material";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import { ChecklistIcon } from "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import { CalendarEventIcon } from "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import { CloseIcon } from "../../../../../components/icons/CloseIcon/CloseIcon.js";
import { DocumentsFolderIcon } from "../../../../../components/icons/DocumentsFolderIcon/DocumentsFolderIcon.js";
import { PatientNumberIcon } from "../../../../../components/icons/PatientNumberIcon/PatientNumberIcon.js";
import { PractitionerIcon } from "../../../../../components/icons/PractitionerIcon/PractitionerIcon.js";
import { TherapyNotesIcon } from "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import { TimerTrackerIcon } from "../../../../../components/icons/TimerTrackerIcon/TimerTrackerIcon.js";
import { TreatmentChairIcon } from "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { DATE_FORMATS } from "../../../../../constants/date/date.js";
import { compareAsc, format, parseISO } from "date-fns";
import "lodash";
import "../../../../components/appointments-picker/appointments-picker.styles.js";
import "clsx";
import "../../../../components/appointments-picker/components/AvailableSlot/AvailableSlot.styles.js";
import "../../../../components/appointments-picker/components/CurrentPeriod/CurrentPeriod.styles.js";
import "../../../../components/appointments-picker/components/NextPeriod/NextPeriod.styles.js";
import "../../../../components/appointments-picker/components/PrevPeriod/PrevPeriod.styles.js";
import "../../../../components/appointments-picker/components/QuickFilter/QuickFilter.styles.js";
import "../../../../components/appointments-picker/components/TimeFrames/TimeFrames.styles.js";
import "../../../../components/appointments-picker/components/UnavailableSlot/UnavailableSlot.styles.js";
import "../../../../components/appointments-picker/components/WorkingDay/WorkingDay.styles.js";
import "color-alpha";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../components/chemistry-info/chemistry-info.styles.js";
import "../../../../components/clinic-location-details/clinic-location-details.styles.js";
import "../../../../components/clinic-location-details/Day/styles.js";
import "../../../../components/clinic-location-details/Map/Map.js";
import "../../../../components/floating-button/floating-button-container/styles.js";
import "../../../../components/floating-button/floating-button.styles.js";
import "../../../../components/news-section/news-section.styles.js";
import { ObfuscatedText } from "../../../../components/obfuscated-text/obfuscated-text.js";
import "../../../../components/pain-details-form/pain-details-form.styles.js";
import "../../../../components/pain-details-form/constants/constants.js";
import "react-slick";
import "../../../../components/task-form/components/Avatar/Avatar.styles.js";
import "../../../../components/task-form/components/Comments/Comments.styles.js";
import "lodash/debounce.js";
import "../../../../components/task-form/components/DatePicker/DatePicker.styles.js";
import "../../../../components/task-form/components/EmployeeMenuItem/EmployeeMenuItem.styles.js";
import "../../../../components/task-form/components/EmployeesDropdown/EmployeesDropdown.styles.js";
import "../../../../components/task-form/components/PatientAutocomplete/PatientAutocomplete.styles.js";
import "@hookform/resolvers/yup";
import "../../../../components/task-form/task-form.entities.js";
import "../../../../components/task-form/task-form.styles.js";
import "../../../../components/task-form/theme/index.js";
import "../../../../components/team-section/constants/constants.js";
import "../../../../components/team-section/components/Rating/styles.js";
import "../../../../components/team-section/team-section.styles.js";
import "../../../../components/testimonials-section/constants.js";
import "../../../../components/testimonials-section/PractitionerTestimonialCard/styles.js";
import "../../../../components/testimonials-video-section/testimonials-video-section.styles.js";
import "../../../../components/employee-select/employee-select.js";
import "../../../../components/ana/utils/shared/Checkbox.js";
import "../../../../components/ana/utils/shared/FormControlLabel.js";
import "../../../../components/ana/components/translate/translate.js";
import "../../../../components/ana/components/checklist-input/checklist-input.styles.js";
import "react-dom";
import "../../../../components/ana/components/address-field/address-field.js";
import "../../../../components/ana/utils/hooks/useFormHelpers.js";
import "../../../../components/ana/utils/hooks/useSubmitCount.js";
import "../../../../components/ana/utils/yup/main.js";
import "../../../../components/ana/components/checkbox-field/checkbox-field.styles.js";
import "../../../../components/ana/components/date-picker-field/date-picker-field.js";
import "../../../../components/ana/components/phone-field/phone-field.js";
import "../../../../components/ana/components/radio-group/radio-group.js";
import "../../../../components/ana/utils/shared/TextFieldLabel.js";
import "../../../../components/ana/components/field-helper-text/field-helper-text.js";
import "../../../../components/ana/components/select-input/select-input.styles.js";
import "../../../../components/ana/components/text-input/text-input.js";
import "../../../../components/ana/components/toggle-field/toggle-field.js";
import "../../../../components/ana/utils/hooks/useFormValue.js";
import "../../../../components/ana/components/form-layout/form-layout.styles.js";
import "../../../../components/ana/utils/shared/Button.js";
import "../../../../components/ana/components/submit-button/submit-button.styles.js";
import "../../../../components/ana/components/toggle-multi-checkbox/toggle-multi-checkbox.styles.js";
import "../../../../components/ana/utils/config/diseases.js";
import "../../../../components/ana/utils/fields/allergiesAndMedications.js";
import "../../../../components/ana/components/insurance-field/insurance-field.js";
import "../../../../components/ana/utils/fields/insurance.js";
import "../../../../components/ana/utils/shared/SectionTitle.js";
import "yup";
import "../../../../components/ana/components/callout/Callout.styles.js";
import "../../../../components/ana/utils/types/contentful.js";
import "../../../../components/ana/utils/fields/contactDetails.js";
import "../../../../components/ana/utils/shared/AddressLayoutItem.js";
import "../../../../components/ana/forms/miscellaneous/miscellaneous.js";
import "../../../../components/ana-toolbox/ana-toolbox.js";
import "../../../../components/ana/utils/config/wishes.js";
import "../../../../components/ana/utils/shared/Radio.js";
import "../../../../components/ana/utils/shared/RadioFormControl.js";
import "../../../../components/ana/utils/shared/RadioFormControlLabel.js";
import "../../../../components/ana/utils/shared/RadioFormLabel.js";
import "../../../../components/ana/utils/shared/RadioGroup.js";
import "../../../../components/ana/utils/shared/ToggleContainer.js";
import "../../../../components/ana/utils/shared/ToggleFormControlLabel.js";
import "../../../../components/ana/forms/preconditions/preconditions.js";
import "../../../../components/ana/components/legal-representative-dialog/legal-representative-dialog.styles.js";
import "../../../../components/ana/utils/fields/personalInformation.js";
import "../../../../components/ana/utils/helpers/DiseaseType.js";
import "../../../../components/ana/utils/shared/TextField.js";
import "../../../../components/ana/components/tag/tag.styles.js";
import "../../../../components/ana/components/disease-field/disease-field.styles.js";
import "../../../../components/ana/components/disease-group-field/disease-group-field.styles.js";
import "../../../../components/ana/utils/helpers/i18n.js";
import "../../../../components/ana/components/ana-dialog/ana-dialog.styles.js";
import "../../../../components/ana/utils/shared/Modal.js";
import "../../../../components/ana/utils/fields/miscellaneous.js";
import "../../../../components/ana/utils/config/wishesAndExpectations.js";
import "../../../../../hooks/useFilterEmployees/useFilterEmployees.js";
import "../../../../components/website/common/button/styles.js";
import "../../../../components/website/jobs/job-description-section/styles.js";
import "../../../../components/website/jobs/job-details-hero-section/styles.js";
import "../../../../components/website/directions-section/styles.js";
import "react-headroom";
import "../../../../components/page-header/context/header-context.js";
import "../../../../components/page-header/components/header-skip/styles.js";
import "../../../../../components/expandable/expandable-dropdown/expandable-dropdown.styles.js";
import "../../../../../components/expandable/expandable-group/expandable-group-context.js";
import "../../../../components/page-header/page-header-mobile/page-header-mobile-content/styles.js";
import "query-string";
import "../../../../components/authentication/components/CredentialsProvider.js";
import "../../../../components/authentication/services/api.js";
import "../../../../components/authentication/components/RouterProvider.js";
import "../../../../components/authentication/components/SecurityConfigProvider.js";
import "../../../../components/authentication/services/i18n.js";
import "../../../../components/authentication/components/auth-container/auth-container.styles.js";
import "../../../../components/authentication/components/login-page/login-page.styles.js";
import "../../../../components/authentication/components/TrustedDeviceProvider.js";
import "../../../../components/authentication/components/HistoryProvider.js";
import { CalendarEdit } from "../../assets/icons/CalendarEdit.js";
import { CalendarTime } from "../../assets/icons/CalendarTime.js";
import { TodoDataTestIds } from "../../constants/dataTestIds.js";
import { getCategoryTitles } from "../../helpers/todo.js";
import { useTodoListProvider } from "../../providers/TodoListProvider.js";
import { Origin } from "../../todo-list.types.js";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard.js";
import { Popover, Header, Title, IconButton, Container, TodoRow, Item, IconContainer, StyledText, PatientIdFrame, Footer } from "./TodoModal.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "@mui/icons-material/ArrowBackIos.js";
import "@mui/icons-material/ExpandMore.js";
import "@mui/material/Card/index.js";
import "@mui/material/CardContent/index.js";
import "@mui/icons-material/KeyboardArrowRight.js";
import "@mui/icons-material/KeyboardArrowLeft.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "google-map-react";
import "../../../../components/obfuscated-text/obfuscated-text.styles.js";
import "../../../../components/pain-details-form/types.js";
import "../../../../components/task-form/assets/icons/Avatar.js";
import "../../../../components/task-form/assets/icons/Logo.js";
import "../../../../components/task-form/assets/icons/Comment.js";
import "../../../../components/task-form/task-form.helpers.js";
import "date-fns/locale";
import "../../../../components/task-form/task-form.types.js";
import "../../../../components/task-form/assets/icons/Important.js";
import "../../../../components/task-form/assets/icons/TaskCategory.js";
import "../../../../components/task-form/assets/icons/TaskDescription.js";
import "../../../../components/task-form/assets/icons/TaskName.js";
import "../../../../components/task-form/theme/overrides/Button.js";
import "../../../../components/task-form/theme/overrides/PickersLayout.js";
import "../../../../components/task-form/theme/overrides/Menu.js";
import "../../../../components/task-form/theme/overrides/Autocomplete.js";
import "../../../../../themes/icon-button/icon-button.js";
import "../../../../../themes/tabs/tabs.js";
import "../../../../components/employee-select/components/employee-search-input/employee-search-input.js";
import "../../../../components/employee-select/components/employee-search-input/employee-search-input.styles.js";
import "../../../../components/employee-select/assets/icons/Search.js";
import "../../../../components/employee-select/employee-select.styles.js";
import "../../../../components/employee-select/assets/icons/Arrow.js";
import "../../../../components/employee-select/assets/icons/Employees.js";
import "formik";
import "../../../../components/ana/utils/helpers/getHasError.js";
import "../../../../components/ana/utils/hooks/useAddressSuggestions.js";
import "use-debounce";
import "../../../../components/ana/utils/helpers/googlePlaces.js";
import "../../../../components/ana/utils/helpers/places.js";
import "../../../../../type/Appointment.js";
import "../../../../components/ana/components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../../../components/ana/utils/entities/Form.js";
import "../../../../components/ana/utils/helpers/toBoolean.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "../../../../components/ana/utils/helpers/createFields.js";
import "../../../../components/ana/utils/helpers/resetFields.js";
import "../../../../components/ana/utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../../../components/ana/utils/helpers/predicates.js";
import "../../../../components/ana/utils/yup/emailValidation.js";
import "../../../../components/ana/utils/helpers/featureFlags.js";
import "../../../../components/ana/utils/helpers/getAgeFromBirthday.js";
import "../../../../components/ana/utils/yup/buildValidationSchema.js";
import "../../../../../type/Disease.js";
import "../../../../components/ana/utils/config/medicaments.js";
import "../../../../components/ana/utils/fields/wishesAndExpectations.js";
import "../../../../components/ana/utils/fields/consents.js";
import "../../../../components/ana/utils/fields/profileInterest.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "date-fns/fp/formatWithOptions";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "../../../../components/ana/utils/helpers/date.js";
import "date-fns/fp/startOfMonth";
import "date-fns/fp/subYears";
import "../../../../components/ana/components/date-picker-field/date-picker-field.styles.js";
import "react-window";
import "@mui/icons-material/ArrowDropDown.js";
import "libphonenumber-js";
import "../../../../components/ana/utils/helpers/phoneMetadata.js";
import "../../../../components/ana/components/phone-field/phone-field.styles.js";
import "../../../../components/ana/components/text-input/text-input.styles.js";
import "use-deep-compare";
import "fuse.js";
import "../../../../components/ana/components/insurance-field/insurance-field-helpers.js";
import "../../../../components/ana/components/insurance-field/Insurance-field.styles.js";
import "../../../../components/ana/utils/helpers/getIsRequired.js";
import "../../../../components/ana/components/form-layout/form-layout.js";
import "../../../../components/ana/utils/helpers/createField.js";
import "../../../../components/ana/components/checkbox-field/checkbox-field.js";
import "../../../../components/ana/components/select-field/select-field.js";
import "../../../../components/ana/components/select-input/select-input.js";
import "../../../../components/ana/components/text-field/text-field.js";
import "../../../../components/ana/components/submit-button/submit-button.js";
import "../../../../../components/loader/loader.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "../../../../../components/loader/loader.styles.js";
import "../../../../components/ana/utils/helpers/getFormInitialErrors.js";
import "../../../../components/ana/components/disease-group-field/disease-group-field.js";
import "../../../../components/ana/components/disease-field/disease-field.js";
import "../../../../components/ana/components/tag/tag.js";
import "@mui/icons-material/Cancel.js";
import "@mui/styles";
import "../../../../components/ana/components/disease-group-field/disease-group-field.helpers.js";
import "../../../../components/ana/utils/hooks/usePreConditionsToggle.js";
import "../../../../components/ana/utils/helpers/scrollToElementIfNotVisible.js";
import "../../../../components/ana/utils/helpers/isInViewport.js";
import "../../../../components/ana/forms/preconditions/preconditions.styles.js";
import "../../../../../type/Employee.js";
import "../../../../../utils/array.js";
import "fast-memoize";
import "../../../../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "../../../../components/website/common/button/button.js";
import "../../../../../hooks/useResponsive.js";
import "../../../../components/smileview-section/hooks/useWindowSize.js";
import "../../../../components/authentication/config.js";
import "../../../../components/authentication/helpers/time.js";
import "../../../../components/authentication/hooks/useStickyState.js";
import "axios";
import "../../../../components/authentication/helpers/credentials.js";
import "../../../../components/authentication/helpers/headers.js";
import "@emotion/styled";
import "react-copy-to-clipboard";
import "../../../../../components/icons/CopyIcon/CopyIcon.js";
import "../../../../../components/snackbar/snackbar.js";
import "../CopyToClipboard/CopyToClipboard.styles.js";
import "@mui/material/IconButton/index.js";
import "@mui/material/Popover/index.js";
const FORMAT_DATE = DATE_FORMATS.DAY_MONTH_YEAR;
const TodoModal = ({ todoDetails, isLoading }) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const {
    labels,
    clinicHasPhonesIntegrations,
    onModalClose,
    onOpenPatientDetails,
    onTodoModal,
    setPhoneMenu,
    onOpenInCalendar,
    setTaskDetailsAnchorEl,
    taskDetailsAnchorEl,
    isObfuscated
  } = useTodoListProvider();
  const categoryTitles = useMemo(() => getCategoryTitles(labels), [labels]);
  const handleShowCallModal = (event) => {
    var _a2;
    setPhoneMenu({ patientReferenceId: ((_a2 = todoDetails == null ? void 0 : todoDetails.patient) == null ? void 0 : _a2.referenceId) || "", anchorEl: event.currentTarget });
  };
  const gender = useMemo(() => {
    if (!todoDetails)
      return void 0;
    const { patient } = todoDetails;
    if (!patient || !patient.gender)
      return null;
    const [firstChar, ...rest] = [...patient.gender];
    return `${firstChar.toUpperCase()}${rest.join("").toLowerCase()}`;
  }, [todoDetails]);
  const handleTodoModalClose = () => {
    onTodoModal(null);
    setPhoneMenu(null);
    onModalClose == null ? void 0 : onModalClose();
  };
  const handleOpenPatientDetails = () => {
    var _a2, _b2;
    onOpenPatientDetails(((_a2 = todoDetails == null ? void 0 : todoDetails.patient) == null ? void 0 : _a2.referenceId) || "", (_b2 = todoDetails == null ? void 0 : todoDetails.patient) == null ? void 0 : _b2.externalId);
    handleTodoModalClose();
  };
  const appointmentDate = useMemo(() => {
    var _a2;
    if (!((_a2 = todoDetails == null ? void 0 : todoDetails.appointments) == null ? void 0 : _a2.length))
      return void 0;
    const appointmentDates = todoDetails.appointments.map(({ start }) => new Date(start));
    return appointmentDates.sort(compareAsc)[0];
  }, [todoDetails]);
  const appointmentDuration = useMemo(() => {
    var _a2;
    if (!((_a2 = todoDetails == null ? void 0 : todoDetails.appointments) == null ? void 0 : _a2.length))
      return void 0;
    return todoDetails.appointments.reduce((acc, { durationInMin }) => acc + durationInMin, 0);
  }, [todoDetails]);
  const practitionerNames = useMemo(() => {
    var _a2, _b2, _c2;
    if ((_a2 = todoDetails == null ? void 0 : todoDetails.costPlan) == null ? void 0 : _a2.employee)
      return (_b2 = todoDetails == null ? void 0 : todoDetails.costPlan) == null ? void 0 : _b2.employee.name;
    if (!((_c2 = todoDetails == null ? void 0 : todoDetails.appointments) == null ? void 0 : _c2.length))
      return void 0;
    return todoDetails.appointments.map(({ employee }) => employee.name).join(", ");
  }, [todoDetails]);
  const taskCreatedAt = useMemo(() => {
    if (!todoDetails)
      return void 0;
    return new Date(todoDetails.createdAt);
  }, [todoDetails]);
  const styledBirthDate = useMemo(() => {
    var _a2;
    if (!((_a2 = todoDetails == null ? void 0 : todoDetails.patient) == null ? void 0 : _a2.birthday))
      return void 0;
    const date = new Date(todoDetails.patient.birthday);
    return format(date, FORMAT_DATE);
  }, [todoDetails]);
  const patientDetails = useMemo(() => {
    if (!styledBirthDate && !gender)
      return void 0;
    return `${styledBirthDate ?? ""} ${styledBirthDate && gender ? "-" : ""} ${gender ?? ""}`;
  }, [styledBirthDate, gender]);
  const cancellationReason = useMemo(() => {
    var _a2;
    if (!((_a2 = todoDetails == null ? void 0 : todoDetails.appointments) == null ? void 0 : _a2.length))
      return void 0;
    return todoDetails.appointments[0].cancellationReason;
  }, [todoDetails]);
  const handleOpenInCalendar = () => {
    onOpenInCalendar(todoDetails);
    handleTodoModalClose();
  };
  const open = Boolean(taskDetailsAnchorEl);
  const showRescheduleButton = (todoDetails == null ? void 0 : todoDetails.origin) === Origin.AUTO_ACCEPTED_HKP_NO_FOLLOWUP;
  const showScheduleButton = (todoDetails == null ? void 0 : todoDetails.origin) === Origin.AUTO_HKP_FOLLOWUP;
  const showCallButton = (todoDetails == null ? void 0 : todoDetails.origin) !== Origin.AUTO_HKP_FOLLOWUP;
  if (!todoDetails || !open || isLoading)
    return null;
  return /* @__PURE__ */ jsxs(
    Popover,
    {
      open,
      id: todoDetails.referenceId,
      anchorEl: taskDetailsAnchorEl,
      onClose: () => setTaskDetailsAnchorEl(null),
      children: [
        /* @__PURE__ */ jsxs(Header, { children: [
          /* @__PURE__ */ jsx(Title, { children: ((_a = labels == null ? void 0 : labels.modal) == null ? void 0 : _a.title) ?? "" }),
          /* @__PURE__ */ jsx(IconButton, { onClick: () => setTaskDetailsAnchorEl(null), children: /* @__PURE__ */ jsx(CloseIcon, {}) })
        ] }),
        /* @__PURE__ */ jsxs(Container, { "data-testid": `${TodoDataTestIds.TodoDetailsModal}-${todoDetails.referenceId}`, children: [
          /* @__PURE__ */ jsxs(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowCategory, children: [
            /* @__PURE__ */ jsxs(Item, { "data-testid": TodoDataTestIds.TodoModalCellCategory, children: [
              /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(ChecklistIcon, {}) }),
              /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: categoryTitles[todoDetails.category] })
            ] }),
            taskCreatedAt && /* @__PURE__ */ jsx(Item, { "data-testid": TodoDataTestIds.TodoModalCellCreatedAt, children: /* @__PURE__ */ jsx(StyledText, { isSecondary: true, variant: "Lato Body 2", children: `${format(taskCreatedAt, FORMAT_DATE)}, ${format(
              taskCreatedAt,
              "HH:mm"
            )}` }) })
          ] }),
          todoDetails.origin === Origin.AUTO_HKP_FOLLOWUP && /* @__PURE__ */ jsx(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowDescription, children: /* @__PURE__ */ jsxs(Item, { children: [
            /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(TherapyNotesIcon, {}) }),
            /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: (_b = labels.modal) == null ? void 0 : _b.followupDescription })
          ] }) }),
          /* @__PURE__ */ jsxs(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowPatient, children: [
            /* @__PURE__ */ jsxs(Item, { "data-testid": TodoDataTestIds.TodoModalCellPatientName, onClick: handleOpenPatientDetails, children: [
              /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(Person, {}) }),
              /* @__PURE__ */ jsx(StyledText, { isLink: true, variant: "Lato Link 1", children: /* @__PURE__ */ jsx(ObfuscatedText, { isVisible: !isObfuscated, children: `${(_c = todoDetails == null ? void 0 : todoDetails.patient) == null ? void 0 : _c.lastName}, ${(_d = todoDetails == null ? void 0 : todoDetails.patient) == null ? void 0 : _d.firstName}` }) })
            ] }),
            /* @__PURE__ */ jsx(Item, { "data-testid": TodoDataTestIds.TodoModalCellPatientDetails, children: /* @__PURE__ */ jsx(StyledText, { isSecondary: true, variant: "Lato Body 2", children: patientDetails }) })
          ] }),
          ((_e = todoDetails == null ? void 0 : todoDetails.patient) == null ? void 0 : _e.externalId) && /* @__PURE__ */ jsx(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowPatientExternalId, children: /* @__PURE__ */ jsxs(Item, { children: [
            /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(PatientNumberIcon, {}) }),
            /* @__PURE__ */ jsxs(PatientIdFrame, { children: [
              /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: todoDetails.patient.externalId }),
              /* @__PURE__ */ jsx(CopyToClipboard, { text: todoDetails.patient.externalId })
            ] })
          ] }) }),
          appointmentDuration && /* @__PURE__ */ jsxs(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowAppointmentTitle, children: [
            /* @__PURE__ */ jsxs(Item, { flex: 1, children: [
              /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(TreatmentChairIcon, {}) }),
              /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: todoDetails.title })
            ] }),
            /* @__PURE__ */ jsxs(Item, { width: 120, children: [
              /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(TimerTrackerIcon, {}) }),
              /* @__PURE__ */ jsxs(StyledText, { variant: "Lato Body 1", children: [
                appointmentDuration,
                " min"
              ] })
            ] })
          ] }),
          appointmentDuration && appointmentDate && /* @__PURE__ */ jsx(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowAppointmentDetails, children: /* @__PURE__ */ jsxs(Item, { children: [
            /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(CalendarEventIcon, {}) }),
            /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: `${format(appointmentDate, FORMAT_DATE)} | ${format(
              appointmentDate,
              "HH:mm"
            )}` })
          ] }) }),
          !!(todoDetails == null ? void 0 : todoDetails.dueDate) && /* @__PURE__ */ jsx(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowDueDate, children: /* @__PURE__ */ jsxs(Item, { children: [
            /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(CalendarTime, {}) }),
            /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: `${format(
              parseISO(todoDetails.dueDate),
              FORMAT_DATE
            )}` })
          ] }) }),
          !!(todoDetails == null ? void 0 : todoDetails.dueDateComment) && /* @__PURE__ */ jsx(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowDueDateComment, children: /* @__PURE__ */ jsxs(Item, { children: [
            /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(CalendarEdit, {}) }),
            /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: todoDetails.dueDateComment })
          ] }) }),
          (todoDetails == null ? void 0 : todoDetails.costPlan) && /* @__PURE__ */ jsx(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowPatientExternalId, children: /* @__PURE__ */ jsxs(Item, { children: [
            /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(DocumentsFolderIcon, {}) }),
            /* @__PURE__ */ jsxs(StyledText, { variant: "Lato Body 1", children: [
              (_f = todoDetails == null ? void 0 : todoDetails.costPlan) == null ? void 0 : _f.type,
              " - ",
              (_g = todoDetails == null ? void 0 : todoDetails.costPlan) == null ? void 0 : _g.externalId
            ] })
          ] }) }),
          practitionerNames && /* @__PURE__ */ jsx(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowPractitioner, children: /* @__PURE__ */ jsxs(Item, { children: [
            /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(PractitionerIcon, {}) }),
            /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: `${practitionerNames}` })
          ] }) }),
          cancellationReason && /* @__PURE__ */ jsx(TodoRow, { "data-testid": TodoDataTestIds.TodoModalRowCancellationReason, children: /* @__PURE__ */ jsxs(Item, { children: [
            /* @__PURE__ */ jsx(TherapyNotesIcon, {}),
            /* @__PURE__ */ jsx(StyledText, { variant: "Lato Body 1", children: cancellationReason })
          ] }) })
        ] }),
        clinicHasPhonesIntegrations && /* @__PURE__ */ jsxs(Footer, { "data-testid": TodoDataTestIds.TodoModalFooter, children: [
          showRescheduleButton && /* @__PURE__ */ jsx(
            Button,
            {
              "data-testid": TodoDataTestIds.TodoModalOpenInCalendarButton,
              onClick: handleOpenInCalendar,
              variant: "bordered",
              children: labels.modal.scheduleAppointment
            }
          ),
          showScheduleButton && /* @__PURE__ */ jsx(Button, { "data-testid": TodoDataTestIds.TodoModalOpenInCalendarButton, onClick: handleOpenInCalendar, children: labels.modal.openInCalendar }),
          showCallButton && /* @__PURE__ */ jsx(Button, { "data-testid": TodoDataTestIds.TodoModalCallPatientButton, onClick: handleShowCallModal, children: labels.modal.callPatient })
        ] })
      ]
    }
  );
};
export {
  TodoModal as default
};
